import { chainConfigs, supportedChains } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import { Button, Icon, Tooltip } from 'ui-framework'
import ChainInfoVM from './ChainInfoVM'

/**
 * Chain switch menu in header
 */
export function ChainInfo({ vm }: { vm: ChainInfoVM }) {
  const { web3Connection } = vm.rootStore
  const tooltip = React.useRef(null)

  return (
    <Tooltip
      id="chain-info"
      className="header-dropdown panel--simple"
      place="bottom"
      clickable={true}
      effect="solid"
      globalEventOff="click"
      data-event-off="click"
      isCapture={true}
      ref={tooltip}
      delayHide={200}>
      {supportedChains
        .filter((chainId) => chainId !== web3Connection.chainId)
        .map((chainId) => {
          return (
            <Button
              key={chainId}
              onClick={() => web3Connection.switchNetwork(chainId)}
              variant="menu">
              <Icon
                size={24}
                name={chainConfigs[chainId].icon.name}
                color={chainConfigs[chainId].icon.color}
                className="margin-right-1"
              />
              {chainConfigs[chainId].chainDetails.shortName}
            </Button>
          )
        })}
      <div className="margin-bottom-05"></div>
    </Tooltip>
  )
}

export default observer(ChainInfo)
